module.exports = __webpack_public_path__ + "static/media/deer_stone_text_01.dc8a41b3.jpg";